import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Lesson_update($lessonData: LessonData) {
    Lesson_update(lessonData: $lessonData) {
      value
    }
  }
`;

const moduleSingleUpdate = async lessonData =>
  graphql(mutation, { lessonData }).then(
    // eslint-disable-next-line camelcase
    ({ Lesson_update }) => Lesson_update
  );

export default moduleSingleUpdate;
